<template>
    <button class="button" id="btnCart" @click="addCart()">{{ title }}</button>
</template>

<script>
import { defineSSRCustomElement } from "vue";
import cart from "../mixins/cart";

export default {
    props: {
        // 課程代碼
        hash:{
            type: String,
            required: true
        },
        // 課程名稱
        name:{
            type: String,
            required: true
        },
        // 案顯示標題 ex: 我要報名
        title: {
            type: String,
            required: true,
            default: "我要報名",
        },
        // api 基礎網址 ex: /pay/cart
        api_url: {
            type: String,
            required: true,
            default: "/pay/cart",
        },
        // 是否登入?
        logined:{
            type: String,
            required: true,
            default: false,
        },
        // 登入網址 ex: /login
        login_url: {
            type: String,
            required: true,
            default: "/login",
        },
    },
    data() {
        return {};
    },
    mixins: [cart],
    methods: {
        async addCart() {
            // var that = this;
            // console.log( this.logined );
            if( this.logined == 'true' ) {
                const result = await window.Swal.fire({
                    title: '確定報名?',
                    text: this.name,
               //     input: 'text',
               //     inputLabel: '使用折扣碼? (若無可不填)',
               //     inputValue: '',
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: '確定',
                    cancelButtonText: '取消'
                });
                // console.log( result );
                if (result.isConfirmed) {
                    this.add(this.hash, null); // result.value );
                }
            } else {
                const result = await window.Swal.fire({
                    title: '請先登入',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: '確定',
                    cancelButtonText: '取消'
                }); //.then((result) => {

                if (result.isConfirmed) {
                    location.href = this.login_url;
                }
                // });

            }
        },
    },
    mounted() {
    //    console.log( 'mounted: logined = ' + this.logined );
    },
};
</script>
